import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reset as filterStateReset, setFilterOptions, getAudits } from 'store/audit/actions';
import { auditLogFilterOptionsSelector } from 'store/audit/selectors';
import { AuditLogOptions } from 'store/audit/types';

//
//  Hook: useAuditLogFilter
//
//  Description:
//  Acts as single source of truth for anything related to AuditLog Main Grid API
//
//  Props:
//  initialOptions?: Partial<AuditLogOptions>
//

export interface AuditLogFilterInterface {
  options: AuditLogOptions;
  fetching: boolean;
  reset: (options?: Partial<AuditLogOptions>) => void;
  filter: (options?: Partial<AuditLogOptions>) => void;
}

//
//  Constant: defaultOptions
//  Description: The default options used for the filter
//
export const defaultOptions: Partial<AuditLogOptions> = {
  filters: [],
  facets: []
};

export function useAuditLogFilter(
  initialOptions: Partial<AuditLogOptions> = {}
): AuditLogFilterInterface {
  const dispatch = useDispatch();
  const persistedOptions = useSelector(auditLogFilterOptionsSelector);

  const options = useRef({
    ...defaultOptions,
    ...initialOptions
  });
  //
  //  Method: reset
  //  Description: Resets the filters to its initial values
  //
  const reset = (opts?: Partial<AuditLogOptions>) => {
    dispatch(filterStateReset());

    if (opts) {
      options.current = { ...options.current, ...opts };
    }
  };

  //
  //  Method: filter
  //  Description: dispatches AuditLogFilter action based on the query and options selected
  //
  const filter = (opts?: Partial<AuditLogOptions>) => {
    const newOptions = { ...options.current, ...opts };
    // TODO : API will add here
    dispatch(getAudits({ pageNumber: 1, totalRowCount: 50, options: newOptions }));

    options.current = newOptions;
    dispatch(setFilterOptions(newOptions));
  };

  return {
    options: persistedOptions,
    reset,
    filter
  } as const;
}
